import { useState, useEffect } from "react";
import { getPotionAssets } from "utils/api";

export const usePotionAssets = (soulId) => {
  const [potions, setPotions] = useState(0);
  const [tamil, setTamil] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (!soulId) return;

    const fetchAssets = async () => {
      try {
        const data = await getPotionAssets(soulId);
        setPotions(data.potions);
        setTamil(data.tamil);
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAssets();
  }, [soulId]);

  return { tamil, potions, isLoading, isError };
};

export default usePotionAssets;
